module.exports = __webpack_public_path__ + "img/xinxi.61595e58.png";